import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProcessImprovementCategoriesDataGrid } from "src/components/views/spc/processImprovement/ProcessImprovementCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/processImprovementCategories")({
	staticData: { title: i18n.t("explanation_categories"), legacyViewKey: "processImprovementCategoriesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProcessImprovementCategoriesDataGrid />;
}
